<template>
    <div>
        <div class="card shadow mb-4">
            <div class="card-body">
                <div class="row mb-4">
                    <heading-icon v-if="step.help" class="mx-1" icon="question" :title="step.title" :pointerCursor="true" @click="openHelpModal" />
                    <heading-icon v-else class="mx-1" icon="chevron-down" :title="step.title" />
                </div>
                <div class="card shadow mb-4 p-2" v-if="step.infoContent && step.infoContent.length > 0">
                    <div class="body">
                        <div class="row">
                            <div class="form-group col-12">
                                <div class="m-auto mb-3" v-dompurify-html="step.infoContent"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card shadow mb-4">
                    <div class="card-body">
                        <questionnaire v-if="step" :questionnaire='step.questionnaire' :stepName="step.title"></questionnaire>
                        <questions v-if="step && step.questionnaire" :questions="step.questionnaire.questions"></questions>
                    </div>
                </div>
                <router-link :to="'/categories/' + step.categoryId" class="btn btn-sm btn-primary">{{$t('BACK_TO_STEPS_LIST')}}</router-link>
            </div>
        </div>
        <b-modal id="questionnaire-help-modal" hide-footer>
            <template v-slot:modal-title>
                <h6 class="m-0 text-primary">{{$t('STEP')}} {{step.title}}</h6>
            </template>
            <div class="d-block text-center">
                <div class="form-group col-12">
                    <h5>{{$t('HELP')}}</h5>
                    <div class="m-auto mb-3" v-dompurify-html="step.help"></div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import Questionnaire from './partials/Questionnaire'
    import Questions from './partials/QuestionsWithAnswers'
    import HeadingIcon from './../misc/HeadingIcon'

    export default {
        components:{
            'questionnaire': Questionnaire,
            'questions': Questions,
            HeadingIcon
        },
        data() {
            return {
                
            }
        },
        computed: {
            cgaPatientSheet: function(){
                return this.$store.getters.cgaPatientSheet;
            },
            patientAnswers: function(){
                return this.$store.getters.patientAnswers;
            },
            step: function(){
                return this.$store.getters.step;
            },
            languages: function(){
                return this.$store.getters.systemLanguages;
            },
            languagesMap: function(){
                return this.languages.reduce(function(map, obj){
                    map[obj.id] = obj.longTitle;
                    return map
                }, {});
            },
            selectedLanguage: function(){
                return this.$store.getters.selectedLanguage;
            },
            selectedCategoryStepDescriptionIndex: function(){
                return this.step.categoryStepDescriptions.findIndex(x => x.languageId === this.selectedLanguage.id);
            },
            cgaPatient: function(){
                return this.$store.getters.cgaPatient;
            },
            stepSequences: function(){
                return this.$store.getters.stepSequences;
            }
        },
        methods: {
            loadStepWithQuestionnaireQuestionsAnswers: function(stepId) {
                let self = this;
                this.$store.dispatch('loadStepWithQuestionnaireQuestionsAnswers', stepId)
                    .then(response => {
                        if(this.cgaPatient) // load patient answers on mounted, if cgaPatient is already loaded.
                        {    
                            this.loadPatientAnswers(this.cgaPatient.id);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },
            loadPatientAnswers: function(patientId){
                let self = this;
                this.$store.dispatch('loadPatientAnswers')
                    .then(response => {
                        //console.log(response);
                        self.addPatientAnswerForTextAreaIfNeeded();
                    })
                    .catch(error => {
                        console.log(error);
                        //self.$router.push("/404");
                    });

            },
            addPatientAnswerForTextAreaIfNeeded: function()
            {
                var patientAnswerIndex = -1;
                var questionIndex = -1;
                if(this.step.questionnaire.questions)
                    questionIndex = this.step.questionnaire.questions.map(function (item) {return item.type}).indexOf(2);
            
                if(questionIndex >= 0)
                    patientAnswerIndex = this.patientAnswers.map(function(item) { return item.questionId; }).indexOf(this.step.questionnaire.questions[questionIndex].id);
                
                
                if(patientAnswerIndex < 0 && questionIndex >= 0 && this.cgaPatient)
                {
                    var newPatientAnswer = {
                        "questionId": this.step.questionnaire.questions[questionIndex].id,
                        "patientId": this.cgaPatient.id,
                        "answerId": this.step.questionnaire.questions[questionIndex].answers[0].id,
                        "textAnswer": '',
                        "patientSheetId": this.cgaPatientSheet.id
                    }
                    this.patientAnswers.push(newPatientAnswer);
                }
            },
            loadCategoryStepSequencesForGivenSteps: function(stepIds){
                let self = this;
                this.$store.dispatch('loadCategoryStepSequencesForGivenSteps', stepIds)
                    .then(response => {
                        //console.log(response);
                    })
                    .catch(error => {
                        console.log(error);
                        //self.$router.push("/404");
                    });
            },
            openHelpModal() {
                this.$bvModal.show('questionnaire-help-modal');
            }
            
        },
        mounted: function () {
            this.loadStepWithQuestionnaireQuestionsAnswers(this.$route.params.stepId);
            if(this.stepSequences == ''){
                this.loadCategoryStepSequencesForGivenSteps([this.$route.params.stepId]);
            }
        },
        watch: {
            cgaPatient: function(val)
            {
                if (val != null) {
                    this.loadPatientAnswers(val.id); // if cgaPatient is not loaded on mounted, the watcher will load the patient answers.
                }
            },
            '$route': function(val){ 
                this.loadStepWithQuestionnaireQuestionsAnswers(this.$route.params.stepId);
                this.loadCategoryStepSequencesForGivenSteps([this.$route.params.stepId]);
            }
        }
    }
</script>
<style lang="scss" scoped>

h5{
    font-size: 20px;
}
h5.question{
        margin-bottom: 0.15rem;
    }

div.container{
  padding-left: 0rem;
  margin-left: 1rem;
}
</style>
